import { useEffect, useRef, useState } from "react";
import "../CSS/slideshow.css"
const img = [
    {
        img: "/4.jpg",
        quote: "\"Opportunities don't happen, you create them.\"",
        style: {
            filter: "brightness(60%)"
        }
    },
    { img: "/7.jpg", quote: "", style: {} },
    { img: "/8.jpg", quote: "", style: {} },
    { img: "/s8.jpg", quote: "", style: {} },
    { img: "/6.jpg", quote: "", style: {} }]

const delay = 2500;


function Slideshow() {
    const [index, setIndex] = useState(0);
    const timeoutRef = useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
            () =>
                setIndex((prevIndex) =>
                    prevIndex === img.length - 1 ? 0 : prevIndex + 1
                ),
            delay
        );

        return () => {
            resetTimeout();
        };
    }, [index]);

    return (
        <div className="slideshow">
            <div
                className="slideshowSlider"
                style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
            >
                {img.map((obj, index) => (
                    <div className="container"
                        style={{ backgroundImage: `url(${obj.img})`, backdropFilter: "blur(20px)", backgroundSize: "cover" }}>
                        <div className="blur-overlay">
                            <img
                                src={obj.img}
                                className="slide"
                                key={index}
                                style={obj.style}
                            >
                            </img>
                            <p className="centered"><b>{obj.quote}</b></p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="slideshowDots">
                {img.map((_, idx) => (
                    <div
                        key={idx}
                        className={`slideshowDot${index === idx ? " active" : ""}`}
                        onClick={() => {
                            setIndex(idx);
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
}

export default Slideshow;

// ReactDOM.render(<Slideshow />, document.getElementById("App"));
